import React from 'react';

import classNames from 'classnames';


type Props = {
  children?: React.ReactNode;
  className?: string;
};

export default function SearchPage({ children, className }: Props) {
  return (<div className={classNames('search-page h-100 d-flex flex-column flex-grow-1', className)}>{children}</div>);
}
